
export class User{
    id: number =  0;
    appRoleId: number = 0;
    name: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    image: string | undefined;
}